import { useParams } from "react-router-dom";
import { useQueryClient } from "react-query";

export default function useIsLastSection(){

    const {course, tab} = useParams();

    const queryClient = useQueryClient();

    const data = queryClient.getQueryData(course);

    const sections = data.chapters.reduce((a,b) => a.concat(b.sections), []);
    
    return sections[sections.length - 1]?.id === tab;
}